import { axiosInstanceMain } from "../../../utils/axiosGlobalUtils";
import { ITenant } from "../types";

export const getFaqs = async (tenant: ITenant, deviceId: string) =>
  await axiosInstanceMain.get(
    `${tenant.path}/locales/faq-sugeridas?deviceId=${deviceId}`
  );
